import { Asset } from '#/graphql/types';
import { Key } from '#/types';

const fields: Key<Asset>[] = [
  'assetTag',
  'serialNumber',
  'state',
  'description',
  'assetTypeId',
  'usefulLife',
  'makeId',
  'modelId',
  'locationId',
  'installDate',
  'acquisitionCostValue',
  'maintenanceCostValue',
  'replacementCost',
  'replacementYear',
  'image',
  'tenantId',
  'condition',
  'riskAssessmentScore',
  'riskScoreDriverNote',
];

export default fields;
